import { render, staticRenderFns } from "./chatContent.vue?vue&type=template&id=3963a670&scoped=true"
import script from "./chatContent.vue?vue&type=script&lang=js"
export * from "./chatContent.vue?vue&type=script&lang=js"
import style0 from "./chatContent.vue?vue&type=style&index=0&id=3963a670&prod&lang=css"
import style1 from "./chatContent.vue?vue&type=style&index=1&id=3963a670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963a670",
  null
  
)

export default component.exports